(function(root){
  'use strict';
  var SHIPPING_THRESHOLD=3500;
  var ELIGIBLE_HANDLES=['sour-strawberry','sour-mango','sour-pineapple'];
  var TIERS=[
    {min:5,pct:10},
    {min:10,pct:15},
    {min:15,pct:20}
  ];

  function tierForQuantity(quantity){
    var tier=null;
    TIERS.forEach(function(candidate){if(quantity>=candidate.min)tier=candidate;});
    return tier;
  }

  function tierStatus(quantity){
    var tier=tierForQuantity(quantity);
    var next=null;
    TIERS.some(function(candidate){
      if(quantity<candidate.min){next=candidate;return true;}
      return false;
    });
    return {
      quantity:quantity,
      unlockedPercent:tier?tier.pct:0,
      nextMinimum:next?next.min:null,
      nextPercent:next?next.pct:null,
      remaining:next?Math.max(0,next.min-quantity):0
    };
  }

  function discountTitle(allocation){
    return allocation && (allocation.title || (allocation.discount_application && allocation.discount_application.title)) || '';
  }

  function isTierDiscount(allocation){
    var title=discountTitle(allocation);
    return /one-time pouches|BUILDPACK(?:5|10|15)/i.test(title);
  }

  function purchaseMessage(options){
    if(!options.isSubscription)return 'One-time purchase. Ships in 1-2 business days.';
    var planName=options.planName||'Every month';
    var percent=options.subscriptionPercent||15;
    return planName+'. Save '+percent+'%. Skip or cancel anytime.';
  }

  function previewSelection(options){
    var cartQuantity=Math.max(0,parseInt(options.cartOneTimeQuantity,10)||0);
    var selectedQuantity=Math.max(1,parseInt(options.selectedQuantity,10)||1);
    var isSubscription=!!options.isSubscription;
    var prospectiveQuantity=cartQuantity+(isSubscription?0:selectedQuantity);
    var tier=isSubscription?null:tierForQuantity(prospectiveQuantity);
    var percent=tier?tier.pct:0;
    var selectedTotal=Math.round(selectedQuantity*(parseInt(options.unitPrice,10)||0)*(100-percent)/100);
    var status=tierStatus(prospectiveQuantity);
    var message;
    if(isSubscription){
      message='Subscriptions save '+(options.subscriptionPercent||15)+'%. Quantity discounts apply to one-time pouches only.';
    }else if(status.unlockedPercent){
      message=status.unlockedPercent+'% unlocked on '+prospectiveQuantity+' one-time pouches.';
    }else{
      message='Add '+status.remaining+' more one-time pouch'+(status.remaining===1?'':'es')+' to save '+status.nextPercent+'%.';
    }
    return {
      prospectiveQuantity:prospectiveQuantity,
      discountPercent:percent,
      selectedTotal:selectedTotal,
      message:message,
      status:status
    };
  }

  function summarizeCart(cart){
    var oneTimeQuantity=0;
    var subscriptionQuantity=0;
    var discountSavings=0;
    (cart.items||[]).forEach(function(item){
      if(ELIGIBLE_HANDLES.indexOf(item.handle)===-1)return;
      if(item.selling_plan_allocation)subscriptionQuantity+=item.quantity||0;
      else{
        oneTimeQuantity+=item.quantity||0;
        var allocationSavings=0;
        (item.discount_allocations||[]).forEach(function(allocation){
          if(isTierDiscount(allocation))allocationSavings+=allocation.amount||0;
        });
        var lineSavings=Math.max(0,(item.original_line_price||0)-(item.final_line_price||0));
        discountSavings+=Math.max(allocationSavings,lineSavings);
      }
    });
    (cart.cart_level_discount_applications||[]).forEach(function(allocation){
      if(isTierDiscount(allocation))discountSavings+=allocation.total_allocated_amount||allocation.amount||0;
    });
    var tier=tierForQuantity(oneTimeQuantity);
    var postDiscountTotal=Math.max(0,cart.total_price||0);
    return {
      eligibleQuantity:oneTimeQuantity,
      oneTimeQuantity:oneTimeQuantity,
      subscriptionQuantity:subscriptionQuantity,
      discountPercent:tier?tier.pct:0,
      discountSavings:discountSavings,
      postDiscountTotal:postDiscountTotal,
      freeShipping:postDiscountTotal>=SHIPPING_THRESHOLD,
      shippingRemaining:Math.max(0,SHIPPING_THRESHOLD-postDiscountTotal),
      checkoutUrl:'/checkout',
      tierStatus:tierStatus(oneTimeQuantity)
    };
  }

  function rewardRail(state){
    var quantity=Math.max(0,parseInt(state.oneTimeQuantity,10)||0);
    var postDiscountTotal=Math.max(0,parseInt(state.postDiscountTotal,10)||0);
    var earned={
      tier5:quantity>=5,
      ship:!!state.freeShipping,
      tier10:quantity>=10,
      tier15:quantity>=15
    };
    var nextTier=quantity<5
      ? {key:'tier5',min:5,pct:10}
      : quantity<10
        ? {key:'tier10',min:10,pct:15}
        : quantity<15
          ? {key:'tier15',min:15,pct:20}
          : null;
    var candidates=[];
    if(nextTier){
      candidates.push({
        key:nextTier.key,
        kind:'tier',
        completion:Math.min(1,quantity/nextTier.min),
        remaining:nextTier.min-quantity,
        percent:nextTier.pct
      });
    }
    if(!earned.ship){
      candidates.push({
        key:'ship',
        kind:'shipping',
        completion:Math.min(1,postDiscountTotal/SHIPPING_THRESHOLD),
        remaining:Math.max(0,parseInt(state.shippingRemaining,10)||SHIPPING_THRESHOLD-postDiscountTotal)
      });
    }
    candidates.sort(function(a,b){return b.completion-a.completion;});
    var next=candidates[0]||null;
    var positions={tier5:17,tier10:42,tier15:70,ship:100};
    var previous={tier5:0,tier10:17,tier15:42,ship:70};
    var progress=0;
    Object.keys(earned).forEach(function(key){
      if(earned[key])progress=Math.max(progress,positions[key]);
    });
    if(next){
      progress=Math.max(progress,previous[next.key]+(positions[next.key]-previous[next.key])*next.completion);
    }
    return {
      earned:earned,
      next:next,
      progress:Math.min(100,progress),
      positions:positions
    };
  }

  /* ---- punch card (shared by the PDP panel and the cart drawer) ----
     cartQty = one-time pouches already in the cart (solid punches).
     pendingQty = pouches the current Add to cart would add (striped punches). */
  var BOLT='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13 2 4 14h7l-1 8 9-12h-7z"/></svg>';
  var PUNCH_KEYS=['tier5','tier10','tier15'];

  function punchMarkup(){
    return TIERS.map(function(t,g){
      var holes='';
      for(var k=g*5+1;k<g*5+5;k++)holes+='<span class="df-punch__hole" data-k="'+k+'">'+BOLT+'</span>';
      holes+='<span class="df-punch__hole df-punch__hole--big" data-k="'+(g*5+5)+'">'+t.pct+'%</span>';
      return '<div class="df-punch__grp df-punch__grp--'+PUNCH_KEYS[g]+'" data-reward="'+PUNCH_KEYS[g]+'" data-min="'+t.min+'" data-pct="'+t.pct+'">'+
        '<div class="df-punch__holes">'+holes+'</div><span class="df-punch__stamp">'+t.min+(t.min===15?'+':'')+' = '+t.pct+'% OFF</span></div>';
    }).join('');
  }

  function punchHeadline(cartQty){
    var status=tierStatus(cartQty);
    return status.nextPercent
      ? status.remaining+' more → <em>'+status.nextPercent+'% off</em>'
      : 'Max deal: <em>20% off</em>';
  }

  function renderPunch(root,cartQty,pendingQty){
    cartQty=Math.max(0,parseInt(cartQty,10)||0);
    pendingQty=Math.max(0,parseInt(pendingQty,10)||0);
    var total=cartQty+pendingQty;
    var nextMin=tierStatus(cartQty).nextMinimum;
    root.querySelectorAll('.df-punch__hole').forEach(function(h){
      var k=parseInt(h.dataset.k,10);
      h.classList.toggle('is-on',k<=cartQty);
      h.classList.toggle('is-pending',k>cartQty&&k<=total);
    });
    root.querySelectorAll('.df-punch__grp').forEach(function(g){
      var min=parseInt(g.dataset.min,10),pct=g.dataset.pct;
      var got=cartQty>=min,onAdd=!got&&total>=min;
      var stamp=g.querySelector('.df-punch__stamp');
      stamp.classList.toggle('is-got',got);
      stamp.classList.toggle('is-pend',onAdd);
      stamp.textContent=got?'✓ '+pct+'% OFF':onAdd?'✓ '+pct+'% on add':min+(min===15?'+':'')+' = '+pct+'% OFF';
      g.querySelector('.df-punch__hole--big').classList.toggle('is-next',!got&&!onAdd&&nextMin===min);
    });
  }

  function earnedKeys(quantity,postDiscountTotal){
    return {tier5:quantity>=5,tier10:quantity>=10,tier15:quantity>=15,ship:postDiscountTotal>=SHIPPING_THRESHOLD};
  }

  root.DFOffer={
    SHIPPING_THRESHOLD:SHIPPING_THRESHOLD,
    punchMarkup:punchMarkup,
    punchHeadline:punchHeadline,
    renderPunch:renderPunch,
    earnedKeys:earnedKeys,
    tierForQuantity:tierForQuantity,
    tierStatus:tierStatus,
    purchaseMessage:purchaseMessage,
    previewSelection:previewSelection,
    summarizeCart:summarizeCart,
    rewardRail:rewardRail
  };
})(typeof window!=='undefined'?window:this);
